export default __webpack_public_path__ + "static/SRF 3200ACS15 - Product Specifications & Technical Data-852764dd52461217811f810ff2056e71.pdf";